// extracted by mini-css-extract-plugin
export default {"EditEvent":"EditEvent_EditEvent__syos3","internalNav":"EditEvent_internalNav__NiOEP","countdown":"EditEvent_countdown__X5fad"};